// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionA_comp__CTntp"};